export default {


    providerInformation:{ id: 'MEDCAL_RX_PROVIDERINFORMATION', text: 'Provider Information:'},
    providerName:{ id: 'MEDCAL_RX_PROVIDERNAME', text: 'Provider Name:'},
    providerType:{ id: 'MEDCAL_RX_PROVIDERTYPE', text: 'Provider Type:'},
    npi:{ id: 'MEDCAL_RX_NPI', text: 'NPI:'},
    providerPrescriber:{ id: 'MEDCAL_RX_PROVIDERPRESCRIBER', text: 'Is the requesting provider the same as the prescriber?'},

    submitterInformation:{ id: 'MEDCAL_RX_SUBMITTER_INFORMATION', text: 'Submitter Information:'},
    submitterFirstName:{ id: 'MEDCAL_RX_SUBMITTER_FIRSTNAME', text: 'Submitter First Name:'},
    submitterLastName:{ id: 'MEDCAL_RX_SUBMITTER_LASTNAME', text: 'Submitter Last Name:'},
    submitterContactPhone:{ id: 'MEDCAL_RX_CONTACTPHONE', text: 'Contact Phone Number:'},
    submitterHippaSecureFaxNumber:{ id: 'MEDCAL_RX_HIPPASECUREFAXNUMBER', text: 'HIPAA Secure Fax Number:'},

    beneficiaryInformation:{ id: 'MEDCAL_RX_BENEFICIARYINFORMATION', text: 'Member Information:'},
    beneficiaryLocation: {id: 'MEDCAL_RX_BENEFICIARYLOCATION', text: 'Member Location:'},
    beneficiaryFirstName:{ id: 'MEDCAL_RX_BENEFICIARYFIRSTNAME', text: 'Member First Name:'},
    beneficiaryLastName:{ id: 'MEDCAL_RX_BENEFICIARYLASTNAME', text: 'Member Last Name:'},
    beneficiaryID:{ id: 'MEDCAL_RX_BENEFICIARYID', text: 'Member ID:'},
    beneficiaryDOB:{ id: 'MEDCAL_RX_BENEFICIARYDOB', text: 'Member DOB:'},

    drugInformation:{ id: 'MEDCAL_RX_DRUGINFORMATION', text: 'Drug Information:'},
    drugName:{ id: 'MEDCAL_RX_DRUGNAME', text: 'Drug Name:'},
    compoundDrugQuestion:{ id: 'MEDCAL_RX_DRUGNAMEQUESTION', text: 'Is the requested medication a compound drug?'},
    drugStrength:{ id: 'MEDCAL_RX_DRUGSTRENGTH', text: 'Drug Strength:'},
    drugNDC:{ id: 'MEDCAL_RX_DRUGNDC', text: 'NDC:'},
    compoundDrug:{ id: 'MEDCAL_RX_COMPOUNDDRUG', text: 'Compound Drug:'},
    compoundInformation:{ id: 'MEDCAL_RX_COMPOUNDINFORMATION', text: 'Compound Information:'},

    priorAuthInformation:{ id: 'MEDCAL_RX_PRIORAUTHINFORMATION', text: 'Prior Auth Information:'},
    patientName:{ id: 'MEDCAL_RX_PATIENTNAME', text: 'Patient Name:'},
    patientHeight:{ id: 'MEDCAL_RX_PATIENTHEIGHT', text: 'Patient Height:'},
    patientWeight:{ id: 'MEDCAL_RX_PATIENTWEIGHT', text: 'Patient Weight:'},
    quantity:{ id: 'MEDCAL_RX_QUANTITY', text: 'Quantity:'},
    daysofSupply:{ id: 'MEDCAL_RX_DAYSOFSUPPLY', text: 'Days of Supply:'},
    dawSelectionCode:{ id: 'MEDCAL_RX_DAWSELECTION', text: 'DAW Selection Code:'},
    numberofAuthorizedRefills:{ id: 'MEDCAL_RX_NUMBEROFAUTHORIZEDREFILLS', text: 'Number of Authorized Refills:'},
    requestType: {id: 'MEDCAL_RX_REQUESTTYPE', text: 'Request Type:'},
    requestBeginDate:{ id: 'MEDCAL_RX_REQUESTBEGINDATE', text: 'PA Request Begin Date:'},
    requestEndDate:{ id: 'MEDCAL_RX_REQUESTENDDATE', text: 'PA Request End Date:'},
    diagnosisCode:{ id: 'MEDCAL_RX_DIAGNOSISCODE', text: 'Diagnosis Codes:'},
    clinicalInformation:{ id: 'MEDCAL_RX_CLINICALINFORMATION', text: 'Clinical Information:'},
    enteralNdc:{ id: 'MEDCAL_RX_ENTERAL_NDC', text: 'NDC:'},
    additionalInformation:{ id: 'MEDCAL_RX_ADDITIONALINFORMATION', text: 'Additional Information:'},
    trialFailure:{ id: 'MEDCAL_RX_TRIALFAILURE', text: 'Trial/Failure:'},

}
